import React from "react";
import "./OntoQl.css";

function OntoQl() {
  return (
    <div id="OntoQl" className="Semantic">
      <div className="sem-logo">
        <img
          src="https://legoai.com/assets/images/OntoQL_logo.svg"
          alt="OntoQL"
          loading="lazy"
          style={{
            paddingLeft:"0%"
          }}
        />
        <h2> Semantic Query Engine</h2>
      </div>
      <div className="center-image-container-ql">
        <img
          src="/assets/images/Semantic_Query_Language.png"
          //src="/assets/images/Sema.png"
          alt="OntoQL,Semantic_Query_Language"
          loading="lazy"
        />
      </div>
    </div>
  );
}

export default OntoQl;
